import handleProviderProvider from "mn-utils/changeProviderProviderSimple";

const React = require('react');
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import isEmail from 'mn-utils/isEmail';

const Caption = require("../../../dumb/Caption/C");
const withState = require("../../../../utils/withState");
const TextField = require("../../../dumb/TextField/A");
const Button = require("../../../dumb/Button/Accept");

import Upload from "./components/Upload";
import {apiV2ReferralMerchantsAdd} from "../../../../api/referral/merchants";
import {backLocation, pushLocation} from "../../../../router";
import {LINK_REFERRAL_MERCHANTS} from "../../../../constants/links";
import {openPopupInfo} from "../../../../emitters/popup";
import ButtonBack from "../../../dumb/Button/BackB";

module.exports = withState((setState, self) => {
  self.state = {
    clicked: false,
    businessName: '',
    email: '',
    website: '',
    aba: '',
    address: '',
    country: '',
    files: []
  };

  const handleProvider = handleProviderProvider(setState);
  const changeProvider = changeProviderProvider(setState);
  const handleChangeLoadingFiles = handleProviderProvider(setState)('loadingFiles');

  const handleChangeBusinessName = changeProvider('businessName');
  const handleChangeEmail = changeProvider('email');
  const handleChangeWebsite = changeProvider('website');
  const handleChangeAba = changeProvider('aba');
  const handleChangeAddress = changeProvider('address');
  const handleChangeCountry = changeProvider('country');

  const handleChangeFiles = handleProvider('files');

  return (state, props) => {
    const {
      clicked,
      businessName,
      email,
      website,
      aba,
      address,
      country,
      files
    } = state;

    const nameRequired = !businessName;
    const mailRequired = !email;
    const mailIsNotValid = !isEmail(email);

    const errors = nameRequired || mailRequired || mailIsNotValid

    const onSubmit = () => {
      if (errors) {
        setState({clicked: true});
        return;
      }

      apiV2ReferralMerchantsAdd({
        retailer_name: businessName,
        retailer_email: email
      }).then(() => {
        pushLocation({
          path: LINK_REFERRAL_MERCHANTS
        });
        openPopupInfo(['User Created']);
      })
    };



    return (
      <div>
        <div className="h48 layoutRow aiC">
          <ButtonBack
            className="m-10 mr10 (c0)>svg"
            onClick={() => pushLocation({
              path: LINK_REFERRAL_MERCHANTS
            })}
          />
          <Caption>Add new Merchant</Caption>
        </div>
        <div className="mt9 layoutRow mh-29 (w50%|mt3|ph29)>1">
          <div>
            <TextField
              placeholder="Company Name"
              value={businessName}
              onChange={handleChangeBusinessName}
              error={clicked && nameRequired}
              maxLength={250}
              helperText="Obligatory field"
            />
          </div>
          <div>
            <TextField
              placeholder="Registered Email"
              value={email}
              onChange={handleChangeEmail}
              error={clicked && (mailRequired || mailIsNotValid)}
              maxLength={250}
              helperText={
                mailRequired
                  ? 'Obligatory field'
                  : mailIsNotValid
                    ? 'Email isn\'t valid'
                    : ''
              }
            />
          </div>
        </div>
        {/*<div className="mt29 mb-14 f12 fw7">Basic KYC Details</div>*/}
        {/*<div className="layoutRow fxwWrap mh-29 (w50%|mt3|ph29)>1">*/}
        {/*  <div>*/}
        {/*    <TextField*/}
        {/*      placeholder="Website Link"*/}
        {/*      value={website}*/}
        {/*      onChange={handleChangeWebsite}*/}
        {/*      error={clicked && !website}*/}
        {/*      maxLength={250}*/}
        {/*      helperText="Obligatory field"*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <div>*/}
        {/*    <TextField*/}
        {/*      placeholder="ABA Number / Routing code (optional)"*/}
        {/*      value={aba}*/}
        {/*      onChange={handleChangeAba}*/}
        {/*      error={clicked && !aba}*/}
        {/*      maxLength={250}*/}
        {/*      // helperText="Obligatory field"*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <div>*/}
        {/*    <TextField*/}
        {/*      placeholder="Business Address"*/}
        {/*      value={address}*/}
        {/*      onChange={handleChangeAddress}*/}
        {/*      error={clicked && !address}*/}
        {/*      // maxLength={250}*/}
        {/*      helperText="Obligatory field"*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <div>*/}
        {/*    <TextField*/}
        {/*      placeholder="Country"*/}
        {/*      value={country}*/}
        {/*      onChange={handleChangeCountry}*/}
        {/*      error={clicked && !country}*/}
        {/*      maxLength={250}*/}
        {/*      helperText="Obligatory field"*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <div className="mt29">*/}
        {/*    <span className="dB f12 fw7">Documents</span>*/}
        {/*    <p className="mt8 f10 lh14">*/}
        {/*      1. Copy of an ID or passport of every director and shareholder/UBO (who owns more than 20% of shares) and their proof of addresses. <br/>*/}
        {/*      2. Proof of the company address. We accept the following address verification documents, issued within 90 days:<br/>*/}
        {/*      - bank statements - with transactions history - we accept digital bank statements too, just send us the original .pdf file (do note that sensitive information such as transactions details can be covered, transactions details);<br/>*/}
        {/*      - utility bills - electricity, water, waste management, fixed internet or phone bills (no mobile phone bills and insurance letters), etc.<br/>*/}
        {/*      - government issued letters - such as letters from government agencies, tax bills, etc.<br/>*/}
        {/*      3. Certificate of the Registration of Incorporation/ registry extract<br/>*/}
        {/*      4. Memorandum of articles of Association / Constitution / By-Laws<br/>*/}
        {/*      5. Confirmation of an active status of the company ( if it’s not indicated in Registration Extract)<br/>*/}
        {/*      6. Confirmation of the director ( if it’s not indicated in Registration Extract)<br/>*/}
        {/*      7. Ownership structure: list of all Shareholders with the specified number of shares<br/>*/}
        {/*    </p>*/}
        {/*  </div>*/}
        {/*  <div className="mt55">*/}
        {/*    <Upload />*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="mt40">
          <Button onClick={onSubmit}>
            Create User
          </Button>
        </div>
      </div>
    );
  }
})
